import { RemoteUsedCardsStatsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const usedCardsStatsService = new RemoteUsedCardsStatsService(httpClient)
